// src/components/CommonComponents/ViewToggle.js
import React from "react";
import { CiGrid41, CiGrid2H } from "react-icons/ci";

const ViewToggle = ({ viewMode, onToggle, className = "", iconSize = 18 }) => (
    <button
        onClick={onToggle}
        className={`flex h-11 w-11 min-w-11 shrink-0 items-center justify-center rounded-xl border border-gray-300 bg-white shadow transition hover:bg-gray-100 ${className}`}
        title="Toggle View"
        type="button"
    >
        {viewMode === "table" ? (
            <CiGrid41 size={iconSize} style={{ color: '#111' }} />
        ) : (
            <CiGrid2H size={iconSize} style={{ color: '#111' }} />
        )}
    </button>
);

export default ViewToggle;
